<template>
  <div :class="'single_photo_album' + (album.submitted ? ' submitted' : '')">
    <v-alert
        v-if="album.submitted && album.confirmed"
        :value="true"
        type="success"
        class="notranslate"
    >{{ str.already_confirmed }}</v-alert>
    <v-alert
        v-if="album.submitted && !album.confirmed"
        :value="true"
        type="error"
        class="notranslate"
    >
      {{ str.not_confirmed }}
      <template v-if="pending_payment_message">
        <a v-if="pending_payment_message['url']"
           :href="pending_payment_message['url']"
           target="_blank"
        >{{pending_payment_message['message']}}</a>
        <a v-else
           href="#"
           @click.prevent="$emit('pay-awards')"
        >{{pending_payment_message['message']}}</a>
      </template>
    </v-alert>
    <h3>{{ str.album }} #{{position + 1}} - {{ award.title }}</h3>
    <v-btn v-if="position >= 1 && !album.confirmed && !album.submitted"
           outline
           color="accent"
           class="remove_album"
           @click="$emit('remove-album', position)"
    >
      {{ str.discart_album }}
      <v-icon class="notranslate" right color="accent" small>close</v-icon>
    </v-btn>
    <div :class="{
      'album_info': true,
      'has_categories': has_categories
    }">
      <v-text-field
        :label="str.album_title_label"
        v-bind:value="album.title"
        v-on:input="updateTitle"
        :rules="[form_rules.required]"
        counter
        maxlength="40"
        :disabled="album.submitted"
      ></v-text-field>
      <v-text-field
          :label="str.album_location_label"
          v-bind:value="album.location"
          v-on:input="updateLocation"
          :rules="[form_rules.required]"
          counter
          maxlength="40"
          :disabled="album.submitted"
      ></v-text-field>
      <v-select
        v-if="has_categories"
        :items="[
          { item_name: str.wedding_album, item_id: 'wedding_album' },
          { item_name: str.pre_wedding_album, item_id: 'pre_wedding_album' },
        ]"
        item-text="item_name"
        item-value="item_id"
        v-model="album.category"
        :label="str.album_category"
        @change="updateCategory"
        :rules="[form_rules.required]"
        :disabled="album.submitted"
      ></v-select>
    </div>
    <v-alert
      v-if="error"
      :value="true"
      type="error"
      class="notranslate"
    >{{str.error_alert}}<br/>{{error}}</v-alert>
    <div class="single_photo_album__upload" v-if="available >= 1">
      <span class="limit">{{ available > 0
          ? `${str.limit_available} ${available} ${str.pictures}`
          : str.limit_reached
      }}</span>
      <input type="file"
             :multiple="(available > 1)"
             ref="image_uploader"
             value="upload dos arquivos"
             @change="upload"
      />
      <v-btn color="accent"
             @click.native="onFocus"
             :loading="loading"
             :disabled="loading || (available < 1)"
      >
        {{str.submit_pictures}}
        <v-icon class="notranslate" right dark>cloud_upload</v-icon>
      </v-btn>
      <span class="note">{{str.photos_alert}}</span>
      <span class="tutorial_link">
        <a href="https://youtu.be/fRDthHhqyXk" target="_blank">{{str.tutorial_link}}</a>
      </span>
    </div>
    <span class="full-album" v-else>{{str.complete_collection}}</span>
    <div class="single_photo_album__gallery">
      <ul v-if="Object.keys(images).length > 0">
        <li v-for="(image, index) in images"
            :key="index"
            :style="album.submitted ? `background-image: url('${image}');` : `background-image: url('data:image/jpeg;charset=utf-8;base64,${image}');`"
        >
          <div class="actions" v-if="!album.submitted">
            <v-tooltip bottom>
              <v-btn slot="activator"
                     flat
                     icon
                     color="#fff"
                     @click="removeImage(index)"
              >
                <v-icon class="notranslate" medium>delete</v-icon>
              </v-btn>
              <span>{{str.remove_photo}}</span>
            </v-tooltip>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import VAlert from 'vuetify/es5/components/VAlert/VAlert'
import VTooltip from 'vuetify/es5/components/VTooltip/VTooltip'
import VTextField from 'vuetify/es5/components/VTextField/VTextField'
import VForm from 'vuetify/es5/components/VForm/VForm'
import { validateImage } from '../utils/functions'
import strings from '../strings/AwardsSinglePhotoAlbum'
import form_rules_mixin from "../utils/form_rules_mixin";
export default {
  name: 'AwardsSinglePhotoAlbum',
  components: { VTextField, VForm, VAlert, VTooltip },
  props: {
    position: {
      type: Number,
      required: true
    },
    album: {
      type: Object,
      required: true
    },
    pending_payment_message: {
      required: true
    },
    award: {
      type: Object,
      required: true
    },
    has_categories: {
      type: Boolean,
      required: true
    }
  },
  mixins: [
      form_rules_mixin
  ],
  data: () => ({
    loading: false,
    error: false,
    limit: 20
  }),
  computed: {
    str: function () {
      const lang = this.$store.state.user.language
      return Object.keys(strings).reduce((acc, key) => {
        return {
          ...acc,
          [key]: strings[key][lang]
        }
      }, {})
    },
    available: function () {
      return (this.limit - this.images.length)
    },
    images: function () {
      return this.album.images
    }
  },
  methods: {
    onFocus: function () {
      this.$refs.image_uploader.click()
    },
    upload: function () {
      console.log('AwardsSinglePhotoAlbum upload')
      this.loading = true
      this.error = false
      if (this.$refs.image_uploader.files.length <= this.available) {
        const images = Array.prototype.map.call(
          this.$refs.image_uploader.files,
          image => validateImage(image, 1200, 800).then(data => data)
        )
        Promise.all(images).then(base64Imgs => {
          this.$emit('update-album', this.position, base64Imgs)
          this.loading = false
        }).catch(error => {
          this.error = `${this.str.file} ${error.message} ${this.str.requirements}.`
          this.loading = false
        })
      } else {
        this.error = `${this.str.submit_limit} ${this.available} ${this.str.files}.`
        this.loading = false
      }
    },
    removeImage: function (index) {
      this.$emit('remove-image', this.position, index)
    },
    updateTitle: function (value) {
      this.$emit('update-title', this.position, value)
    },
    updateLocation: function (value) {
      this.$emit('update-location', this.position, value)
    },
    updateCategory: function (value) {
      this.$emit('update-category', this.position, value)
    }
  }
}
</script>

<style lang="scss">
  .single_photo_album {
    margin: 24px 0 0;
    background: #f5f5f5;
    padding: 36px;
    border-radius: 8px;
    position: relative;
    &.submitted > *:not(.v-alert) {
      opacity: 0.6;
    }
    .v-alert {
      margin: 0 0 18px 0;
      a {
        color: #fff;
      }
    }
    .remove_album {
      position: absolute;
      top: 36px;
      right: 36px;
      margin: 0;
      .v-icon--right {
        margin-left: 8px;
      }
    }
    .album_info {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      grid-template-rows: auto;
      grid-gap: 18px;
      &.has_categories {
        grid-template-columns: repeat(3, 1fr);
      }
    }
    .single_photo_album__upload {
      padding-bottom: 36px;
      margin-top: 18px;
      text-align: center;
      input[type=file] {
        display: none;
      }
      .limit {
        display: block;
        font-size: 16px;
      }
      .note {
        display: block;
        margin-top: 12px;
      }
      .tutorial_link {
        display: inline-block;
        margin: 4px 0;
        background: var(--warning-color);
        padding: 4px 6px;
        line-height: 24px;
        a {
          color: #fff;
          text-decoration: none;
        }
      }
    }
    .full-album {
      display: block;
      font-size: 16px;
      padding-bottom: 36px;
    }
    .single_photo_album__gallery {
      ul {
        display: grid;
        grid-template-columns: repeat(5, 1fr);
        grid-gap: 4px;
        margin: 0;
        padding: 0;
        list-style: none;
        li {
          display: block;
          position: relative;
          background-color: #ccc;
          padding-top: 66.67%;
          background-position: center;
          background-size: cover;
          &:hover .actions {
            opacity: 1;
          }
          .actions {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            background: rgba(0,0,0,0.5);
            display: flex;
            justify-content: center;
            align-items: center;
            opacity: 0;
            transition: opacity 0.3s cubic-bezier(0.4, 0.0, 0.2, 1);
          }
        }
      }
    }
  }
</style>
